<!--使用弹窗替代详情页，暂时弃用-->
<template>
  <div class="appDetails" v-if="appInfo">
    <!--返回按钮-->
    <div style="text-align: left;">
      <div class="gobackBtn" @click="emitGoback">
        <img :src="require('@/assets/market/u505.png')"
          style="height: 25px;display: inline-block;vertical-align: middle;">
        <span style="display: inline-block;vertical-align: middle;font-size: 18px;margin-left: 5px;">返回</span>
      </div>
    </div>
    <!--应用软件详情-->
    <div class="cardContainer">
      <div class="cardTitle">应用软件详情</div>
      <div class="cardContent">
        <div style="display: flex;margin-top: 40px;">
          <!--左侧图标-->
          <div class="imgContainer">
            <div class="appImg">
              <img :src="appInfo.imsUrl" width="130px" height="130px" class="imgCenter">
            </div>
          </div>
          <!--右侧内容-->
          <div class="textContainer" style="flex: 1;">
            <!--标题-->
            <div style="font-size: 22px;color: #008FE0;font-weight: bold;">{{ appInfo.applyName }}</div>
            <!--明细-->
            <div style="font-size: 18px;">
              <div class="textItem">
                <div class="infoTitle">销售数量：</div>
                <div class="infoValue">{{ appInfo.downloadsNumbers }}</div>
              </div>
              <div class="textItem">
                <div class="infoTitle">大小：</div>
                <div class="infoValue appSize app">{{ appInfo.appSize }}</div>
              </div>
              <div class="textItem">
                <div class="infoTitle">版本号：</div>
                <div class="infoValue">
                  <div style="display: inline-block;text-align: left;">{{ appInfo.version }}</div>
                </div>
              </div>
              <!--              <div class="textItem">-->
              <!--                <div class="infoTitle">价格：</div>-->
              <!--                <div class="infoValue appPrice">{{appInfo.price}}</div>-->
              <!--              </div>-->
              <div class="textItem">
                <div class="infoTitle">类型：</div>
                <div class="infoValue">{{ appInfo.applytypeName }}</div>
              </div>
              <div class="textItem">
                <div class="infoTitle">更新时间：</div>
                <div class="infoValue">{{ toYMD(appInfo.updateTime) }}</div>
              </div>
              <div class="textItem">
                <div class="infoTitle">开发者：</div>
                <div class="infoValue">格力电器股份有限公司</div>
              </div>
            </div>
            <!--操作按钮-->
            <!--            <div style="margin: 20px 0;">-->
            <!--              <div class="btnForDtl" style="margin-left: 150px;" @click="downloadAPP">立即购买</div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!--适用条件-->
    <div class="cardContainer">
      <div class="cardTitle">适用条件</div>
      <div class="cardContent">
        <div style="margin: 0 0 20px 20px;">
          <div class="lineItem">
            <div class="lineTitle">运行环境：</div>
            <div class="lineContent">{{ appInfo.operatingCarrier }}</div>
          </div>
          <div class="lineItem">
            <div class="lineTitle">支持的设备类型：</div>
            <div class="lineContent">{{ appInfo.deviceTypes }}</div>
          </div>
          <div class="lineItem">
            <div class="lineTitle">支持的设备厂家：</div>
            <div class="lineContent">{{ appInfo.deviceManufacturers }}</div>
          </div>
          <div class="lineItem">
            <div class="lineTitle">支持的设备协议：</div>
            <div class="lineContent">{{ appInfo.deviceProtocols }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--功能描述-->
    <div class="cardContainer">
      <div class="cardTitle">功能描述</div>
      <div class="cardContent">
        <div style="margin-bottom: 20px;word-break: break-word;">{{ appInfo.applyDescription }}</div>
      </div>
    </div>
    <!--接口示意图-->
    <div class="cardContainer">
      <div class="cardTitle">接口示意图</div>
      <div class="cardContent">
        <div class="imgContainer">
          <div class="appImg">
            <img :src="appInfo.imageUrl" width="130px" height="130px" class="imgCenter">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadApp } from "../../../api/appStore/appHome";
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "appDetails",
  props: {
    appInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(['getLoginStatus'])
  },
  data() {
    return {
    }
  },
  methods: {
    //----------工具类----------
    // 日期转年-月-日格式
    toYMD(date) {
      if (date) {
        let time = new Date(date);
        return time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
      }
      return '-';
    },
    //----------动作类----------
    // 返回应用软件首页
    emitGoback() {
      this.$emit('return');
    },
    // 下载
    downloadAPP() {
      // 参数活的要用appid
      let appId = this.appInfo.appId;
      if (appId) {
        downloadApp(appId).then(res => {
          this.$emit('update'); // 触发父组件数据更新
          this.appInfo.downloadsNumbers++;
          let downLink = res.returnData.appUrl;
          if (downLink) {
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = downLink;
            // link.setAttribute("download", "自定义的下载文件名");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }).catch(e => e);
      } else {
        this.$msg('', 'error');
      }
    }
  }
}
</script>

<style scoped lang="less">
.appDetails {
  font-size: 18px;
  cursor: default;
}

/*返回按钮样式*/
.gobackBtn {
  line-height: 42px;
  height: 42px;
  margin-left: 10px;
  cursor: pointer;
  display: inline-block;
}

/*框架样式*/
.cardContainer {
  color: #333333;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  box-sizing: border-box;
  background-color: white;
  margin-bottom: 10px;

  .cardTitle {
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    border-bottom: 2px solid #f0f0f0;
    cursor: default;
  }

  .cardContent {
    margin-top: 15px;
    text-align: left;
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
  }
}

/*应用软件详情样式*/
.imgContainer {
  display: inline-block;
  width: 180px;
  margin-right: 20px;
  margin-bottom: 10px;

  .appImg {
    margin: auto;
    width: 140px;
    height: 140px;
    /*border: 1px solid #008FE0;*/
    border: 1px solid #617799;
    border-radius: 5px;
    box-sizing: border-box;
    line-height: 135px; // 图裂放中间位置
    text-align: center;

    .imgCenter {
      display: inline-block;
      vertical-align: middle;
    }
  }
}

/*应用软件详情信息条样式*/
.textItem {
  display: inline-block;
  margin: 20px 150px 10px 0;
  width: 310px;
  /*height: 54px;*/
  height: 0px;

  .infoTitle {
    text-align: left;
    display: inline-block;
    color: #555555;
    width: 90px;
    vertical-align: top;
  }

  .infoValue {
    text-align: left;
    display: inline-block;
    color: #000000;
    max-width: 220px;
    vertical-align: top;
    float: right;
    white-space: nowrap;
  }

  .appPrice:after {
    content: '元';
  }

  .app:after {
    padding-left: 10px;
    content: 'KB';
  }
}

/*适用条件信息条样式*/
.lineItem {
  margin: 20px 0;
  display: flex;

  .lineTitle {
    color: #555;
    display: inline-block;
    width: 180px;
    vertical-align: top;
    flex-shrink: 0;
    /*text-align: right;*/
  }

  .lineContent {
    display: inline-block;
    vertical-align: top;
    flex: 1;
    color: #000;
  }
}


/*操作按钮样式*/
.btnForDtl {
  display: inline-block;
  background-color: #617799;
  color: #FFFFFF;
  font-size: 20px;
  width: 140px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}
</style>
